module.exports = __webpack_public_path__ + "img/home2.16f4485c.jpg";